import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
import i18n from '@/plugins/i18n';
import { useStore } from 'vuex';
import { langSelectFieldOptions } from '@/components/Main/main.config';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelectField',
  setup(__props) {

const router = useRouter();
const store = useStore();
const getCurrLang = computed(
  () => store.getters['globalState/app/getCurrLang'],
);
const setCurrLang = (lang) => store.commit('globalState/app/setCurrLang', lang);

i18n.global.locale = getCurrLang.value;

function onLangChange(lang) {
  setCurrLang(lang);
  i18n.global.locale = lang;
  router.go(0);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(RexSelectV3, {
      customStyle: { width: '8rem' },
      value: getCurrLang.value,
      options: _unref(langSelectFieldOptions),
      onOnChange: onLangChange
    }, null, 8, ["value", "options"])
  ]))
}
}

})